<template>
    <div class="assign">
        <b-modal
            id="password-modal"
            title="Change your password"
            ok-title="Update"
            size="md"
            centered
            @ok="e => { e.preventDefault(); updatePassword(); }">
            <b-form-group
                label="Current password"
                :invalid-feedback="errors.current"
                :state="errors.current === null ? null : false">
                <b-form-input
                    id="current_password"
                    type="password"
                    v-model="current"
                    autocomplete="off"
                    :state="errors.current === null ? null : false"
                    @input="errors.current = null"
                    required/>
            </b-form-group>

            <b-form-group
                label="New password"
                :invalid-feedback="errors.password"
                :state="errors.password === null ? null : false">
                <b-form-input
                    id="new_password"
                    type="password"
                    v-model="password"
                    autocomplete="new-password"
                    :state="errors.password === null ? null : false"
                    @input="errors.password = null"
                    aria-required="true"
                    required/>
            </b-form-group>

            <b-form-group
                label="Confirm new password"
                :invalid-feedback="errors.confirm"
                :state="errors.confirm === null ? null : false">
                <b-form-input
                    id="repeat_new_password"
                    type="password"
                    v-model="confirm"
                    autocomplete="new-password"
                    :state="errors.confirm === null ? null : false"
                    @input="errors.confirm = null"
                    aria-required="true"
                    required/>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            user: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                current: '',
                password: '',
                confirm: '',
                errors: {
                    current: null,
                    confirm: null,
                    password: null,
                }
            }
        },
        computed: {},
        methods: {
            updatePassword() {
                let token = this.$store.state.token;
                let url = this.$store.state.apiURL + 'auth/me/change-password';
                let method = 'POST';

                this.errors.current = null;
                this.errors.confirm = null;
                this.errors.password = null;

                axios({
                    url: url,
                    data: {
                        current: this.current,
                        password: this.password,
                        confirm: this.confirm,
                    },
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        let user = response.data.data;
                        this.$emit('ok', user);

                        this.current = '';
                        this.confirm = '';
                        this.password = '';
                        this.errors.current = null;
                        this.errors.confirm = null;
                        this.errors.password = null;

                        this.$bvModal.hide('password-modal');

                        this.$bvModal.msgBoxOk('Your password was updated successfully.', {
                            title: 'Password updated',
                            okVariant: 'danger'
                        });

                    })
                    .catch(error => {
                        const data = error.response.data;

                        this.errors.current = data.errors?.current?.[0] ?? null;
                        this.errors.confirm = data.errors?.confirm?.[0] ?? null;
                        this.errors.password = data.errors?.password?.[0] ?? null;
                    });
            },
        },
    }
</script>
<style scoped>
    .pull-right {
        float: right;
    }

    .error {
        color: red;
    }
</style>
